import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { ConfirmModal } from "ceco-modal";
import graphql from "babel-plugin-relay/macro";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";

export default function SectionDeleteModal(props) {
  const { trigger, section, recipeName, sectionId, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState();
  const t = useTranslation();

  function deleteIngredientToRecipe() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
      };

      commitMutation(environment, {
        mutation: sectionDeleteModal_delete_Mutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
        // configs: [
        //   {
        //     type: "RANGE_DELETE",
        //     parentID: recipeId,
        //     connectionInfo: [
        //       {
        //         key: "SectionsList_section",
        //         rangeBehavior: "append",
        //       },
        //     ],
        //     edgeName: "recipeSection",
        //   },
        // ],
      });
    });
  }

  const onSubmit = async () => {
    setLoading(true);
    deleteIngredientToRecipe()
      .then((a) => {
        toast.success(t("message.deleted_section"));
        setModalOpen(false);
        setLoading(false);
        refetchData();
      })
      .catch((e) => {
        setLoading(false);
        if (Array.isArray(e)) {
          toast.error(e[0].message);
        } else {
          toast.error(e.errors[0].message);
        }
      });
  };

  return (
    <ConfirmModal
      modalOpen={modalOpen}
      title={t("modalTitle.removeSection")}
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          setFormData({ id: sectionId });
        },
      })}
      onClose={() => setModalOpen(false)}
      showCloseButton={true}
      description={
        <div>
          {t("warning.section_remove", {
            sectionName: section?.name,
            recipeName: recipeName,
          })}
        </div>
      }
      renderActions={() => (
        <div>
          <Button
            disabled={loading}
            color="red"
            onClick={() => {
              onSubmit();
            }}
          >
            {t("action.delete")}
          </Button>
          <Button
            color="green"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            {t("action.cancel")}
          </Button>
        </div>
      )}
    />
  );
}
const sectionDeleteModal_delete_Mutation = graphql`
  mutation SectionDeleteModalMutation($id: ID!) {
    recipeSectionDelete(input: { id: $id }) {
      deleted
    }
  }
`;
